import axios from "axios";
import { GOPEOPLE_API_URL } from "../config";
import { getValidGoPeopleToken } from "../auth/authTokenManagerGoPeople";
import { getAuthInfosFromCookie } from "../utils";
import { refreshAccessToken } from "./auth";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  failedQueue = [];
};

const goPeopleAxios = axios.create({
  baseURL: GOPEOPLE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

goPeopleAxios.interceptors.request.use(
  async (config) => {
    const token = await getValidGoPeopleToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);


goPeopleAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.log("goPeopleAxios response error:", error);
    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      originalRequest._retry
    ) {
      return Promise.reject(error);
    }
    console.log(" ----401 detected in goPeopleAxios");
    originalRequest._retry = true;

    const authInfos = getAuthInfosFromCookie();
    const refreshToken = authInfos?.refreshToken;

    if (!refreshToken) {
      return Promise.reject(error);
    }
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return goPeopleAxios(originalRequest);
      });
    }

    isRefreshing = true;
    try {
      const tokens = await refreshAccessToken(refreshToken);

      processQueue(null, tokens.accessToken);
      console.log("-----GoPeople token refreshed after 401");
      originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;
      console.log("-----Retrying original request after token refresh...");
      return goPeopleAxios(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default goPeopleAxios;
